import { createAction } from 'typesafe-actions';

export const setUserTimeZone = createAction('USER_TIMEZONE/SET_USER_TIMEZONE', (resolve) => {
  return (payload: { timezone: string; offset: number }) => resolve(payload);
});
